import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { Credential, RegistrationResponse } from "../registration.model";

import { DgaRegistrationFormData, DgaRegistrationPayload } from "./dga-registration.model";

export const ACTION_PREFIX = "[DGA Registration]";

export const DGA_REGISTRATION_ACTION_TYPE = {
	getRegistrationToken: `${ACTION_PREFIX} Get Registration Token`,
	getRegistrationTokenSuccess: `${ACTION_PREFIX} Get Registration Token Success`,
	getRegistrationTokenFail: `${ACTION_PREFIX} Get Registration Token Fail`,

	setRegistrationDetails: `${ACTION_PREFIX} Set Registration Form Data ${SYNC_SUFFIX}`,
	resetRegistrationState: `${ACTION_PREFIX} Reset Registration Details ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class DgaRegistrationAction {
	getRegistrationToken(payload: DgaRegistrationPayload): ActionWithPayload {
		return {
			type: DGA_REGISTRATION_ACTION_TYPE.getRegistrationToken,
			payload,
		};
	}

	getRegistrationTokenSuccess(response: RegistrationResponse, credential?: Credential): ActionWithPayload {
		return {
			type: DGA_REGISTRATION_ACTION_TYPE.getRegistrationTokenSuccess,
			payload: {
				token: response.token,
				hashedEmail: response.hashedEmail,
				credential,
			},
		};
	}

	getRegistrationTokenFail(error: AppError): ActionWithPayload {
		return {
			type: DGA_REGISTRATION_ACTION_TYPE.getRegistrationTokenFail,
			payload: error,
		};
	}

	setRegistrationDetails(payload: DgaRegistrationFormData): ActionWithPayload {
		return {
			type: DGA_REGISTRATION_ACTION_TYPE.setRegistrationDetails,
			payload,
		};
	}

	resetRegistrationState(): Action {
		return {
			type: DGA_REGISTRATION_ACTION_TYPE.resetRegistrationState,
		};
	}
}
